import React from 'react'

const Coursedetails = ({selectedCourse}) => {
  return (
    <div className='w-full'>
        <h2 className='text-[#22BEFF] text-2xl font-bold'>কোর্স সম্পর্কে বিস্তারিত</h2>
        <div className='w-full border border-[#22BEFF33] mt-[1rem] rounded-md  gap-8 p-4'>
            <div className='flex flex-col gap-4'>
                <p className='text-gray-400 mb-4 text-justify text-xl'>{selectedCourse?.course_details}</p>
        
            </div>
           
        </div>
    </div>
  )
}

export default Coursedetails